import React from 'react';

const AuthContext = React.createContext<{ authenticated: boolean; setAuthenticated: (v: boolean) => void }>({
  authenticated: false,
  setAuthenticated: () => {},
});

export default AuthContext;
